import React from 'react';
import Footer from '../components/footer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../menu/header2';
import { Link } from "@reach/router";
import map1 from '../../assets/1.png';
import map2 from '../../assets/2.png';
import scene1 from '../../assets/scene.png';
import render from '../../assets/chatgpt21.png';
import Allterrain from '../../assets/Allterrain.mp4';

const CaseStudies = () => (
  <div>
    <Header />
    <section style={{ paddingTop: '10em', backgroundColor: 'black' }}>
      <h1 style={{ textAlign: 'center', color: 'white' }}>
        Architecture Visualization Services
      </h1>

      <Container>
        <Row className="mb-4">
          <p style={{ color: 'white', fontSize: '14px' }}>
            Now offering architecture and landscape architecture visualization services. I can use all of the skills I have learned
            in 3D modeling, AI, branding, and programming to quickly help you visualize your project or brand it to help you sell it.
          </p>
        </Row>

        <Row className="mb-5" style={{ justifyContent: 'center' }}>
          <Col xs={12} md={5} className="mb-4 d-flex flex-column justify-content-center">
            <h4 style={{ fontWeight: 'bold', color: 'white' }}>
              Interactive Visualizations using Game Engines
            </h4>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src="https://www.youtube.com/embed/NBfqK_N3LB8?si=ocyFQwMTgNo7zePW"
                title="Interactive Visualization Video"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </Col>

          <Col xs={12} md={5} className="mb-4 d-flex flex-column justify-content-center">
            <h4 style={{ fontWeight: 'bold', color: 'white' }}>
              Custom 3D Modeling from Schematics
            </h4>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src={Allterrain}
                title="Custom 3D Modeling Video"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </Col>
        </Row>

        <Row className="mb-5 align-items-center">
          <h4 style={{ fontWeight: 'bold', color: 'white' }}>Workflow</h4>
          <p style={{ color: 'white' }}>
            Realistic results are achieved through a combination of various technologies including AI for quick iterations.
            Final renders available upon request.
          </p>

          <Col xs={12} md={5} className="mb-4 d-flex flex-column justify-content-center">
           
           
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src="https://www.youtube.com/embed/hQRe8Q1X9Ks?si=Mrc1GUAc12adkMPH"
                title="Workflow Demo Video"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </Col>

          {[{ img: map1, label: 'Line Map' }, { img: map2, label: 'Depth Map' }, { img: scene1, label: '3D Model' }, { img: render, label: 'AI Iteration' }].map((item, index) => (
            <Col
              key={index}
              xs={12}
              md={4}
              className="mb-4 d-flex flex-column align-items-center justify-content-center"
            >
              <img
                src={item.img}
                alt={item.label}
                style={{
                  width: '100%',
                  maxWidth: '250px',
                  height: 'auto',
                  objectFit: 'cover',
                  borderRadius: '10px',
                  boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.3)',
                  backgroundColor: 'white',
                }}
              />
              <p style={{ color: 'white', textAlign: 'center', marginTop: '0.5em' }}>
                {item.label}
              </p>
            </Col>
          ))}
        </Row>
      </Container>
    </section>

    <Footer />
  </div>
);

export default CaseStudies;
